export default __webpack_public_path__ + "9f88609305bfd8a3418edd70fbc921ab.woff";